import { pubsub } from "utils";

// 定义待处理操作类型
type PendingOperation = {
  type: "report_access";
  params: {
    type: "crypto" | "stock";
    symbol?: string;
    id?: string;
    isModal?: boolean;
  };
};

// 定义报告访问事件类型
export const REPORT_ACCESS_EVENTS = {
  REQUEST_ACCESS: "report_access_request", // 请求访问报告
  LOGIN_REQUIRED: "report_access_login_required", // 需要登录
} as const;

// 全局状态：报告访问待处理操作
class ReportAccessStore {
  private static instance: ReportAccessStore;
  public pendingOperation: PendingOperation | null = null;

  static getInstance() {
    if (!this.instance) {
      this.instance = new ReportAccessStore();
    }
    return this.instance;
  }

  /**
   * 触发报告访问请求
   * 这个方法会自动处理登录状态检查和事件分发
   */
  requestReportAccess(params: PendingOperation["params"], isLoggedIn: boolean) {
    if (!isLoggedIn) {
      // 未登录：保存操作并触发登录事件
      this.setPendingOperation({ type: "report_access", params });
      pubsub.emit(REPORT_ACCESS_EVENTS.LOGIN_REQUIRED, params);
    } else {
      // 已登录：直接触发访问事件
      pubsub.emit(REPORT_ACCESS_EVENTS.REQUEST_ACCESS, params);
    }
  }

  setPendingOperation(operation: PendingOperation | null) {
    this.pendingOperation = operation;
  }

  getPendingOperation() {
    return this.pendingOperation;
  }

  clearPendingOperation() {
    this.pendingOperation = null;
  }
}

export const reportAccessStore = ReportAccessStore.getInstance();
